<template>
  <div class="table-grid">
    <DashboardPanel title="Slow-Moving Stock" subtitle="Top 10 items unsold the longest (bought 30+ days ago, none sold).">
      <div class="table-responsive">
        <a-table :columns="slowMovingColumns" :data-source="slowMovingRows" :pagination="false" row-key="itemid" size="small" />
      </div>
    </DashboardPanel>

    <DashboardPanel
      class="recent-panel"
      title="Recent Transactions"
      subtitle="Latest sale activity with quick filters."
      icon="flag"
    >
      <template #actions>
        <button class="link-btn plain" @click="$router.push('/saleslist')">View All</button>
      </template>
      <div class="transaction-tabs">
        <button
          v-for="tab in transactionTabs"
          :key="tab.key"
          :class="{ active: activeTab === tab.key }"
          @click="activeTab = tab.key"
        >
          {{ tab.label }}
        </button>
      </div>
      <div class="recent-table">
        <div class="recent-head">
          <span>Date</span>
          <span>Customer</span>
          <span>Status</span>
          <span>Total</span>
        </div>
        <div v-for="row in activeRows" :key="row.key" class="recent-row">
          <span>{{ row.date }}</span>
          <div class="customer-cell">
            <span class="avatar">{{ row.initials }}</span>
            <div>
              <strong>{{ row.customer }}</strong>
              <small>{{ row.reference }}</small>
            </div>
          </div>
          <span class="status-pill" :class="row.statusClass">{{ row.status }}</span>
          <strong class="amount-cell">{{ row.total }}</strong>
        </div>
        <div v-if="!activeRows.length" class="empty-state compact">No transactions in this tab.</div>
      </div>
    </DashboardPanel>
  </div>
</template>

<script>
import DashboardPanel from "./DashboardPanel.vue";
import { buildRecentSaleRows, buildSlowMovingRows } from "../dashboardCards";

const SLOW_MOVING_COLUMNS = [
  { title: "Item", dataIndex: "itemname", key: "itemname" },
  { title: "Category", dataIndex: "categoryname", key: "categoryname" },
  { title: "Remaining Qty", dataIndex: "remainingqty", key: "remainingqty", align: "right" },
  { title: "Last Purchase", dataIndex: "latest_purchase_date", key: "latest_purchase_date" },
];

// Only sales have data so far; the other tabs show an empty state until their feeds exist.
const TRANSACTION_TABS = [
  { key: "sale", label: "Sale" },
  { key: "purchase", label: "Purchase" },
  { key: "quotation", label: "Quotation" },
  { key: "expenses", label: "Expenses" },
  { key: "invoices", label: "Invoices" },
];

// Slow-moving stock and the recent transactions list.
export default {
  name: "OperationsSection",
  components: { DashboardPanel },
  props: {
    slowMoving: { type: Array, required: true },
    recentBills: { type: Array, required: true },
  },
  data() {
    return {
      activeTab: "sale",
      transactionTabs: TRANSACTION_TABS,
      slowMovingColumns: SLOW_MOVING_COLUMNS,
    };
  },
  computed: {
    slowMovingRows() {
      return buildSlowMovingRows(this.slowMoving);
    },
    activeRows() {
      return this.activeTab === "sale" ? buildRecentSaleRows(this.recentBills) : [];
    },
  },
};
</script>
